import { Box, Stack, Typography, Button } from "@mui/material";
import PageTitle from "../components/PageTitle";
import { useAuth } from "../../shared/auth/AuthContext";
import BoxCard from "../../shared/components/BoxCard";

export default function Profile() {
  const { user, logout } = useAuth();

  return (
    <Box>
      <PageTitle title="Profile" />
      <BoxCard title="Your Account">
        <Stack direction="row" alignItems="center" spacing={2}>
          {user?.avatarUrl && (
            <img
              style={{ width: 80, height: 80, borderRadius: "50%" }}
              src={user.avatarUrl}
              alt={user.username}
            />
          )}
          <Box flex={1}>
            <Typography variant="h6">{user?.displayName ?? user?.username}</Typography>
            <Typography color="text.secondary">@{user?.username}</Typography>
          </Box>
        </Stack>
      </BoxCard>
      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" color="error" onClick={logout}>
          Log out
        </Button>
      </Box>
    </Box>
  );
}
